import {omit} from 'underscore';

export function normalizeNumberEnum<TEnum>(enumObject: TEnum) {
  return omit(enumObject, (v, k) => !Number.isNaN(+k!));
}
